import { useEffect, useRef } from 'react';
import { projectFirestore, timestamp } from '../firebase/config';

const VISITOR_KEY = 'spe_visitor_id';
const FIRST_SEEN_KEY = 'spe_visitor_first_seen';
const HEARTBEAT_MS = 30000;

function generateVisitorId() {
  return `v_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = generateVisitorId();
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

function getFirstSeenIso() {
  let firstSeenIso = localStorage.getItem(FIRST_SEEN_KEY);
  if (!firstSeenIso) {
    firstSeenIso = new Date().toISOString();
    localStorage.setItem(FIRST_SEEN_KEY, firstSeenIso);
  }
  return firstSeenIso;
}

export default function useVisitorPresence(pathname) {
  const visitorIdRef = useRef(null);

  useEffect(() => {
    visitorIdRef.current = getVisitorId();
  }, []);

  useEffect(() => {
    if (!visitorIdRef.current) return undefined;

    const ref = projectFirestore.collection('siteVisitors').doc(visitorIdRef.current);
    const firstSeenIso = getFirstSeenIso();

    const writePresence = (isOnline) => {
      ref.set(
        {
          visitorId: visitorIdRef.current,
          currentPath: pathname || '/',
          isOnline,
          isAdminSession: (pathname || '/').startsWith('/admin'),
          userAgent: navigator.userAgent,
          firstSeen: firstSeenIso,
          lastSeen: timestamp(),
        },
        { merge: true }
      ).catch(() => {
        // Ignore transient write failures to avoid UI interruption.
      });
    };

    writePresence(true);

    const timerId = setInterval(() => {
      writePresence(true);
    }, HEARTBEAT_MS);

    const handleBeforeUnload = () => {
      writePresence(false);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      clearInterval(timerId);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [pathname]);
}
